export const authorizationBearer = (token?: string) => ({
  authorization: token ? `Bearer ${token}` : "",
})
